import { render, staticRenderFns } from "./FaqBody.vue?vue&type=template&id=bc77dd0e&"
import script from "./FaqBody.vue?vue&type=script&lang=js&"
export * from "./FaqBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports